export default {
  login: {
    phone: 'Phone Number',
    phoneNumber: 'Phone Number',
    password: 'Password',
    accountNumber: 'Account Number',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    forgotPassword: 'Forgot Password?',
    contactAdmin: 'Contact Admin',
    loginButton: 'Login',
    register: 'Register',
    confirm: 'Confirm',
    changePassword: 'Change Password',
    noAccount: 'Or don\'t have an account'
  },
  register: {
    title: 'Register',
    verifyOTP: 'Verify OTP Code',
    registerSuccess: 'Register Success',
    registrationComplete: 'Your registration was successful',
    enterPhonePrompt: 'Please enter your phone number',
    next: 'Next',
    back: 'Back',
    otpSent: 'OTP code will be sent to your mobile phone',
    otpSentTo: 'OTP code will be sent to your mobile phone',
    phone: 'Number',
    phoneNumber: 'Number',
    enterOtp: 'Enter OTP code from your mobile phone',
    enterOTP: 'Enter OTP code from your mobile phone',
    confirmOtp: 'Confirm OTP',
    confirmOTP: 'Confirm OTP',
    resendOtp: 'Resend OTP code',
    resendOTP: 'Resend OTP code',
    enterPasswordPrompt: 'Please enter your password',
    password: 'Password',
    setPassword: 'Set password (6 characters or more)',
    confirmPassword: 'Re-enter password',
    selectBankPrompt: 'Please select your bank',
    selectBank: 'Select Bank',
    accountNumber: 'Account Number',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankHint: 'Please fill in all information correctly, otherwise you will not be able to withdraw',
    registerButton: 'Register',
    success: 'Registration successful',
    thankYouMessage: 'Thank you for registering. You can use the username and password below to login',
    username: 'Username',
    loginButton: 'Login',
    or: 'Or',
    alreadyHaveAccount: 'Already have an account'
  },
  registerErrors: {
    errorTitle: 'Error!',
    otpTitle: 'OTP!',
    enterOTP: 'Please enter the OTP code you received!',
    invalidOTP: 'Invalid OTP code, please check again!',
    otpNotFound: 'OTP code not found in system, please contact admin',
    selectBank: 'Please select a bank!',
    enterAccountNumber: 'Please enter account number!',
    enterFirstName: 'Please enter first name!',
    enterLastName: 'Please enter last name!',
    enterPhone: 'Please enter phone number!',
    phoneLength: 'Phone number must be exactly 10 digits!',
    phoneExists: 'This phone number is already registered. If you have problems, please contact',
    accountExists: 'This account number is already registered. If you have problems, please contact',
    passwordMinLength: 'Password must be at least 6 characters!',
    passwordMismatch: 'Passwords do not match!',
    invalidCredentials: 'Phone number / password is incorrect!'
  },
  messages: {
    title: 'Message!',
    enterPhone: 'Please enter your mobile number!',
    enterPassword: 'Please enter your password!',
    invalidCredentials: 'Phone number / password is incorrect!',
    contactAdminError: 'Please contact admin',
    checkPasswordData: 'Please check your password data correctly!',
    passwordChangedSuccess: 'Password changed successfully',
    completeAllInfo: 'Please complete all information!',
    enterPhoneAndAccount: 'Please enter phone number and account number',
    enterNewPassword: 'Please enter new password'
  },
  languages: {
    th: 'Thai',
    en: 'English',
    my: 'Myanmar',
    ch: 'Chinese'
  },
  main: {
    heroTitle: 'Packed with special events<br>and exclusive privileges',
    heroSubtitle: 'Thailand\'s biggest lineup of daily activities for every player',
    heroCta: 'Register Now',
    searchPlaceholder: 'Search games or providers...',
    playButton: 'Play Now',
    titles: {
      favorite: 'Favorite Games',
      hot: 'Popular Games',
      new: 'New Games',
      casinoAll: 'All Casinos',
      casinoProvider: 'Provider {name}',
      sport: 'Sports',
      fishAll: 'All Fishing Games',
      fishProvider: 'Fishing Games - {name}',
      slotAll: 'All Slot Games',
      slotProviders: 'Slot Providers',
      slotProvider: 'Slot Games - {name}',
      card: 'Card Games'
    }
  },
  header: {
    register: 'Register',
    registerNow: 'Register Now',
    login: 'Login',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    account: 'Account',
    nav: {
      slot: 'Slot',
      casino: 'Casino',
      sport: 'Sport',
      event: 'Privilege',
      privilege: 'Privilege',
      promotion: 'Promotion',
      cashback: 'Cashback',
      continue: 'Continuous Deposit',
      continuousDeposit: 'Continuous Deposit',
      partner: 'Partner',
      rewards: 'Redeem Rewards',
      redeemRewards: 'Redeem Rewards'
    },
    auth: {
      register: 'Register',
      login: 'Login',
      logout: 'Logout',
      logoutConfirm: 'Do you want to logout?'
    },
    loginModal: {
      title: 'Login',
      phonePlaceholder: 'Phone Number',
      passwordPlaceholder: 'Password',
      forgotPassword: 'Forgot Password',
      submit: 'Login',
      problem: 'Having problems',
      contactSupport: 'Contact Customer Support'
    },
    registerModal: {
      title: 'Register',
      phonePlaceholder: 'Phone Number',
      confirm: 'Confirm',
      back: 'Back'
    },
    otp: {
      message: 'OTP code will be sent to your mobile phone',
      phoneNumber: 'Number',
      placeholder: 'Enter OTP code from your mobile phone',
      confirm: 'Confirm OTP',
      resend: 'Resend OTP code'
    },
    password: {
      newPlaceholder: 'Set password (6 characters or more)',
      confirmPlaceholder: 'Re-enter password',
      currentPlaceholder: 'Current password',
      new: 'New password',
      confirmNew: 'Re-enter new password'
    },
    bank: {
      accountNumberPlaceholder: 'Enter account number',
      firstnamePlaceholder: 'Enter first name',
      lastnamePlaceholder: 'Enter last name',
      warning: 'Please fill in all information correctly, otherwise you will not be able to withdraw money'
    },
    registerSuccess: {
      title: 'Registration successful',
      usernameLabel: 'Username: ',
      passwordLabel: 'Password: '
    },
    depositModal: {
      title: 'Deposit via PromptPay',
      modalTitle: 'Deposit Funds',
      click: 'Click',
      copy: 'Copy',
      scbBank: 'Siam Commercial Bank',
      ttbBank: 'TMBThanachart Bank',
      kbank: 'Kasikorn Bank',
      gsbBank: 'Government Savings Bank',
      truemoney: 'TrueMoney Wallet',
      promptPay: 'PromptPay Deposit',
      warning: 'Please use only the account number you registered with',
      promotionNotice: 'If you want to receive a promotion, please click receive promotion before transferring money',
      generatingInfo: 'Generating QR Code, please wait... do not close this window.',
      generatingWarning: 'This QR code can be used only once. Do not scan it again.',
      receive: 'Receive',
      notReceive: 'Skip',
      noBonusNotice: 'Deposit without bonus; withdraw instantly with no conditions.',
      amountPlaceholder: 'Enter deposit amount',
      slipReminder: 'If funds don\'t arrive within 5 minutes, upload your slip here!',
      closeButton: 'Close Window',
      confirm: 'Confirm Deposit',
      confirmDeposit: 'Notify Deposit',
      loading: 'Loading...',
      generatingButton: 'Generating QR Code...',
      minAmountError: 'Amount must be more than {amount} THB',
      depositError: 'PromptPay deposit has an issue',
      contactAdmin: 'Please contact admin',
      depositSuccess: 'PromptPay deposit successful',
      qrWarning: 'Warning: This QR CODE can only be paid once. Do not repeat the transaction. Repeating may cause delayed deposits.'
    },
    withdrawModal: {
      modalTitle: 'Withdraw Funds',
      amountPlaceholder: 'Amount to withdraw',
      minimumNotice: '- Minimum withdrawal 100 THB',
      confirmButton: 'Confirm Withdrawal',
      withdrawNotice: 'Withdrawal Notice',
      turnoverComplete: 'Turnover complete! You can withdraw {amount} THB. Click confirm to proceed.',
      turnoverCompleteSimple: 'Turnover complete! Click confirm to proceed with withdrawal.'
    },
    promotion: {
      title: 'Promotion',
      receive: 'Receive Promotion'
    },
    support: {
      customerService: 'Customer Service',
      service24h: '24 Hours Support'
    }
  },
  promotionPage: {
    heroTitle: 'Supercharged promos & nonstop events<br>The hottest rewards right now',
    heroSubtitle: 'Endless games and standout offers — ranked #1 for a reason.',
    heroCta: 'Register Now'
  },
  eventPage: {
    heroTitle: 'Packed with events<br>Epic rewards happening now',
    heroSubtitle: 'Wall-to-wall games and perks—only the best make it here.',
    heroCta: 'Register Now',
    alerts: {
      error: 'Error!',
      success: 'Success',
      creditExceeds: 'You have more than 4 credits and cannot play!',
      creditExceeds10: 'You have more than 10 credits and cannot play!',
      checkinAlready: 'You have already checked in today. Please come back tomorrow!',
      checkinSuccess: 'Check-in successful',
      checkinVerify: 'Please verify your check-in eligibility!',
      enterCode: 'Please enter code',
      confirm: 'Confirm',
      cancel: 'Cancel',
      codeInvalid: 'Please check your code!',
      codeAlreadyUsed: 'You have already received the free code!'
    }
  },
  cashbackPage: {
    title: 'Cashback',
    playSummary: 'Play Summary',
    deposit: 'Deposits',
    withdraw: 'Withdrawals',
    totalIncome: 'Total Earnings',
    transferButton: 'Transfer to main wallet'
  },
  partnerPage: {
    title: 'Affiliate Link',
    copy: 'Copy',
    copyTitle: 'Copy',
    copySuccess: 'Copied successfully.',
    shareHint: 'Share your link on any channel to earn with us.',
    earningsTitle: 'Affiliate Earnings',
    levelOne: 'Direct Referrals',
    levelTwo: 'Second-level Referrals',
    levelOneIncome: 'Direct Referral Earnings',
    levelTwoIncome: 'Second-level Earnings',
    totalIncome: 'Total Earnings',
    summaryNote: '*Summary as of yesterday',
    table: {
      code: 'Code',
      date: 'Date',
      deposit: 'Deposit',
      withdraw: 'Withdraw'
    },
    levelOneModalTitle: 'Direct Referrals',
    levelTwoModalTitle: 'Second-level Referrals'
  },
  continuePage: {
    title: 'Continuous Deposit',
    defaultPromotion: '7-Day Continuous Deposit',
    bonus: 'Bonus',
    rulesHtml: '<p style="text-align:center;padding:30px;font-size:16px;">'
      + '<b>• Deposit for 7 consecutive days</b><br>'
      + '✨ Daily total deposit 999 THB — bonus 100 THB<br>'
      + '✨ Daily total deposit 1,999 THB — bonus 200 THB<br>'
      + '✨ Daily total deposit 2,999 THB — bonus 300 THB<br>'
      + '✨ Daily total deposit 3,999 THB — bonus 400 THB<br>'
      + '✨ Daily total deposit 4,999 THB — bonus 500 THB<br>'
      + '✨ Daily total deposit 5,999 THB — bonus 600 THB<br>'
      + '✨ Daily total deposit 6,999 THB — bonus 700 THB<br>'
      + '✨ Daily total deposit 7,999 THB — bonus 800 THB<br>'
      + '✨ Daily total deposit 8,999 THB — bonus 900 THB<br>'
      + '✨ Daily total deposit 9,999 THB — bonus 1,000 THB<br>'
      + '• Bonus can be used on selected casino & game providers only<br>'
      + '• Slot games must not purchase bonus features (free spins)<br>'
      + '• Maximum withdrawal is 3x the bonus amount<br>'
      + '• Bonus is playable credit only and will be removed when withdrawing. '
      + 'Example: bonus 100 THB; withdrawable 300 THB. Any credit above 300 THB will be removed.<br>'
      + '• Bonus can be claimed automatically daily from 08:00 – 23:45 (GMT+7)<br>'
      + '• Balance must be below 10 THB before claiming the bonus'
      + '</p>'
  },
  huayPage: {
    title: 'Deposit Conditions',
    depositCondition: '**Deposit 300 THB or more to get lottery participation rights instantly (only on draw days)**',
    rewardText: 'Guess correctly and win 500 credits with 2x turnover',
    conditionsTitle: '📣 Event Participation Conditions 📣',
    condition1: '1. Minimum deposit 300 THB or more',
    condition2: '2. 1 slip can receive 1 prediction right',
    condition3: '3. Predict the 2-digit top prize unlimited times',
    condition4: '4. Prediction closes at 15:00 on draw day',
    condition5: '5. Must have 1 turnover play before 16:00 on draw day',
    condition6: '6. Free credit rewards will be added within 19:00 on draw day',
    confirmButton: 'Confirm Lottery Bet',
    loading: 'loading...',
    loadingText: 'loading',
    successMessage: 'Lottery bet placed successfully 😘',
    checkRightsAlert: 'Please check your betting rights',
    errorMessage: 'An error occurred while saving data. Please try again',
    okButton: 'OK'
  },
  rouletPage: {
    title: 'Roulette Free Credits',
    depositCondition: '**Deposit 1000 THB or more to get instant spin rights (Mondays and Fridays only)**',
    spinButton: 'Spin Now',
    spinRights: 'Spin Rights',
    rounds: 'times',
    depositPrompt: 'Deposit 1000 THB or more to get instant spin rights',
    creditExceeds: 'You have more than 4 credits and cannot play!',
    noPermissionTitle: 'No Roulette Spin Rights',
    noPermission: 'Deposit 1000 THB or more to get instant spin rights (Mondays and Fridays only)',
    loseMessage: 'Sorry, no prize this time',
    winMessage: 'Congratulations! You won',
    credit: 'credit',
    coin: 'coins',
    okButton: 'OK'
  },
  spinPage: {
    title: 'Wheel Free Credits',
    depositCondition: '**Deposit 500 THB or more to get instant spin rights (Mondays and Fridays only)**',
    spinRights: 'Spin Rights',
    rounds: 'rounds',
    depositPrompt: 'Deposit 500 THB or more to get instant spin rights',
    creditExceeds: 'You have more than 4 credits and cannot play!',
    noPermissionTitle: 'No Wheel Spin Rights',
    noPermission: 'Deposit 500 THB or more to get instant spin rights (Mondays and Fridays only)',
    winMessage: 'You received',
    credit: 'credit',
    points: 'Points',
    formula: 'Calculation formula',
    hours: 'hours',
    okButton: 'OK'
  },
  common: {
    conditionTitle: 'Condition',
    conditionMessage: 'Your balance must be below 5 THB to claim this reward.',
    confirm: 'Confirm',
    back: 'Back',
    haveProblem: 'Having problems',
    contactSupport: 'Contact Customer Support'
  },
  account: {
    info: 'Account Info',
    joinedPromotion: 'Joined Promotions',
    history: 'Transaction History',
    logout: 'Logout',
    confirmLogout: 'Do you want to logout?',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password'
  },
  home: {
    category: {
      jackpot: 'Jackpot Games',
      popular: 'Popular Games',
      new: 'New Games',
      slot: 'Slot Games',
      liveCasino: 'Live Casino',
      review: 'Customer Withdrawal Reviews'
    },
    game: {
      play: 'Play',
      lobby: 'Enter Lobby',
      allGames: 'All games',
      gamesCount: 'Games'
    },
    badge: {
      hot: 'Hot',
      new: 'New'
    },
    popular: {
      title: 'Popular Online Slots with Frequent Wins',
      highPayout: 'High Payout Rate',
      easyBonus: 'Easy Bonus',
      funGraphics: 'Fun Graphics and Sound',
      playAnytime: 'Play Anytime 24/7'
    },
    slot: {
      title: 'Play All Game Providers - No Transfer Needed',
      allProviders: 'All Game Providers Available',
      directWeb: 'Direct Web Service',
      autoSystem: 'Auto System',
      safe: '100% Safe'
    },
    casino: {
      title: 'World-Class Live Casino!',
      baccarat: 'Baccarat',
      sicbo: 'Sic Bo',
      dragonTiger: 'Dragon Tiger',
      poker: 'Poker',
      roulette: 'Roulette',
      blackjack: 'Blackjack',
      hilo: 'Hi-Lo',
      bannerTitle: 'Premium Live Casino',
      bannerSubtitle: 'Baccarat | Sic Bo | Dragon Tiger | Roulette'
    },
    feature: {
      smartWallet: {
        title: 'Smart Wallet',
        detail: 'Play All Games<br>No Transfer Needed'
      },
      rank: {
        title: 'No.1 in Thailand',
        detail: 'Technology and Games<br>From Around the World'
      },
      transaction: {
        title: 'Fast Deposit - Withdraw',
        detail: 'Super Fast Transactions<br>With Bot AI System'
      },
      everywhere: {
        title: 'Play Anywhere',
        detail: 'Easy to Use System<br>All Devices Supported'
      },
      support: {
        title: 'Service with Care',
        detail: 'Customer Service<br>24/7 Every Day'
      },
      promotion: {
        title: 'Great Promotions for You',
        detail: 'Wide Variety of Activities<br>and Promotions in Thailand'
      }
    },
    announcement: {
      title: '📢 Important Announcement',
      noShowAgain: 'Do not show this message again',
      acknowledge: 'Acknowledge'
    }
  },
  rewardsPage: {
    heroTitle: 'Plenty of Rewards <br>  Redeem Anytime',
    heroSubtitle: 'Collect coins to redeem all available rewards anytime',
    redeemButton: 'Redeem Now',
    confirmMessage: 'Do you want to redeem {name}?',
    confirmYes: 'Confirm',
    confirmNo: 'Cancel',
    creditRedeemTitle: 'Redeem Credit',
    creditRedeemError: 'Cannot redeem credit because your balance is more than 5 THB'
  },
  historyPage: {
    title: 'Transaction History',
    dateTime: 'Date/Time',
    type: 'Type',
    amount: 'Amount',
    status: 'Status',
    types: {
      wheel: 'Wheel',
      treasureBox: 'Treasure Box',
      roulette: 'Roulette',
      checkin: 'Check-in',
      code: 'Code',
      scratch: 'Scratch Card',
      giftBox: 'Gift Box',
      continuousDeposit: 'Continuous Deposit',
      partner: 'Partner',
      cashback: 'Cashback',
      deposit: 'Deposit',
      withdraw: 'Withdraw'
    },
    statuses: {
      completed: 'Completed',
      cancelled: 'Cancelled',
      pending: 'Pending'
    }
  },
  footer: {
    contact: {
      customerService: 'Customer Service',
      service24h: '24 Hours Support'
    },
    actions: {
      home: 'Home',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      contactUs: 'Contact Us'
    },
    description: 'We are the largest online casino provider in 2024, with the best system development and improvements by expert teams who help bettors throughout their betting journey 24 hours a day, allowing you to enjoy to the fullest whenever you encounter any problems. We are also an online gambling provider with a variety of game formats for you to choose from for diverse entertainment. Additionally, you will find worthwhile promotions in full measure, offering returns on investment in ways you have never experienced before.',
    banks: {
      title: 'Banks We Support'
    },
    partners: {
      title: 'Our Partners'
    },
    autoSystem: 'With fast and modern AUTO deposit-withdraw system',
    copyright: 'Copyright ©2024, All Rights Reserved. TOKYO789'
  }
}
